import { hasRole } from "../../auth/role-policy";
import type { AuthenticatedUser } from "./model";

export const isUnassignedCustomer = (user: AuthenticatedUser | null): boolean =>
  hasRole(user, ["Customer"]) && user?.company === null;

export const canEditCompanyProjects = (
  user: { role?: string; companyRole?: string | null } | null,
): boolean =>
  hasRole(user, ["Admin"]) ||
  user?.companyRole === "Owner" ||
  user?.companyRole === "Editor";

export const canManageCompanyMembers = (
  user: { role?: string; companyRole?: string | null } | null,
): boolean =>
  hasRole(user, ["Admin"]) ||
  (hasRole(user, ["Customer"]) && user?.companyRole === "Owner");

export const canManageCompanyDetails = canManageCompanyMembers;

export const getCompanyConsultationMode = (
  user: { role?: string; companyRole?: string | null } | null,
): "editor" | "viewer" | null => {
  if (canManageCompanyDetails(user)) return null;
  if (user?.companyRole === "Editor") return "editor";
  if (user?.companyRole === "Viewer") return "viewer";
  return null;
};

export const canSelectCompanyScope = (
  user: { role?: string } | null,
): boolean => hasRole(user, ["Admin"]);

export const canManageProjectReport = (
  user: { role?: string } | null,
): boolean => hasRole(user, ["Admin"]);
